import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

import { resetContainerPaddings } from "utils/styles";

const heroStyles = {
  wrapper: (): SystemStyleObject<Theme> => ({
    mx: resetContainerPaddings,
  }),
  background:
    (backgroundImage: string, caseStudyFolder: string) =>
    (theme: Theme): SystemStyleObject<Theme> => ({
      backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/${caseStudyFolder}/${backgroundImage})`,
      position: "relative",
      backgroundSize: "cover",
      backgroundPosition: "center",
      minHeight: { xs: 400, md: 500, lg: 600 },
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",

      "&::before": {
        content: "''",
        position: "absolute",
        zIndex: 1,
        width: "100%",
        left: 0,
        height: "20%",
        pointerEvents: "none",
        bottom: 0,
        backgroundImage: `linear-gradient(0deg, ${theme.palette.background.default}, transparent)`,
      },
    }),
  container: (): SystemStyleObject<Theme> => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    zIndex: 10,
    position: "relative",
  }),
  title: (theme: Theme): SystemStyleObject<Theme> => ({
    fontSize: { xs: 40, sm: 60, md: 80, lg: 100 },
    textTransform: "uppercase",
    fontWeight: 800,
    lineHeight: 1,
    mb: 4,
    color: theme.palette.secondary.main,
  }),
  subtitle: (): SystemStyleObject<Theme> => ({
    fontSize: { xs: 16, md: 20, lg: 24 },
    fontWeight: 400,
    maxWidth: 900,
    lineHeight: 1.5,
    color: "grey.400",
  }),
};

export default heroStyles;
